<script>
import ChargemapB2BButton from "./ChargemapB2BButton.vue";
export default {
  name: "ChargemapFilterButton",
  components: {
    ChargemapB2BButton
  },
  props: {
    filtersCount: {
      type: Number,
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  emits: ["clearFilters"],
  data() {
    return {
      xButtonHovered: false
    };
  },
  methods: {
    clearFilters() {
      this.$emit("clearFilters");
    }
  }
};
</script>

<template>
    <ChargemapB2BButton variant="secondary">
        <template #icon>
            <IconFilter class="size-5 text-slate-500" />
        </template>
        <div class="flex flex-row gap-2 text-slate-500">
            {{ $t("filters.filters") }}

            <div
                v-if="filtersCount > 0"
                class="h-6 px-2 bg-primary-100 font-medium text-primary-800 rounded-sm"
            >
                {{ filtersCount }}
            </div>

            <button
                v-if="filtersCount > 0 && !readOnly"
                type="button"
                @mouseenter="xButtonHovered = true"
                @mouseleave="xButtonHovered = false"
                @click.stop="clearFilters"
            >
                <IconX
                    class="size-6 transition-colors duration-300 ease-in-out select-all pointer-events-auto"
                    tabindex="0"
                    :is-solid="xButtonHovered"
                    :class="xButtonHovered ? 'text-red-500' : 'text-slate-500'"
                />
            </button>
        </div>
    </ChargemapB2BButton>
</template>
